import React, { useEffect, useState } from "react";
import banner1 from "../../assets/images/banner005.png";
import banner2 from "../../assets/images/banner003.jpeg";

const BannerSlider = () => {
  const banners = [banner1, banner2];
  const [current, setCurrent] = useState(0);
  const [fade, setFade] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setFade(true);

      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % banners.length);
        setFade(false);
      }, 400);
    }, 4000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="banner-slider">
      <img
        src={banners[current]}
        alt="banner"
        className={`banner-image-slide ${fade ? "fade" : ""}`}
      />
    </section>
  );
};

export default BannerSlider;
